
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetogoainnovacrystacabservice() {



    const cardData =
    {
        keyword: 'Pune to Goa Innova Crysta Cab Service',
        heading: 'Meghana Cab : Pune to Goa Innova Crysta Cab Service',
        headingDescription: 'Meghana Cab offers Pune to Goa Innova Crysta Cab Service, providing a premium, comfortable, and stress-free road journey across approximately 450–460 km through the scenic Western Ghats to Goa. Our meticulously maintained Innova Crysta vehicles feature plush leather seating, ample legroom, generous luggage space, and air-conditioning—ideal for family trips, corporate travel, or leisurely getaways. With door-to-door pickup from anywhere in Pune, experienced chauffeurs familiar with the route, GPS-enabled vehicles, and transparent booking options (one-way, round-trip, or hourly rentals), Meghana Cab ensures a seamless and enjoyable travel experience. Backed by 24/7 customer support and flexible scheduling, your Pune to Goa Innova Crysta Cab journey is designed for comfort, reliability, and convenience from start to finish.',


        top: 'Top Places to Visit in Goa with Meghana Cab',

"topPlaces": [
  {
    "title": "Mahalakshmi Temple",
    "description": "One of India’s most revered Shakti Peethas, this 7th-century Hemadpanti-style temple is dedicated to Goddess Mahalakshmi. The black-stone idol (Ambabai) weighs ~40 kg and attracts devotees year-round, especially during Kirnotsav and Navratri. The majestic architecture and spiritual ambiance make it Kolhapur’s heart and soul."  
  },
  {
    "title": "Rankala Lake & Shalini Palace",
    "description": "Rankala is a historic lake formed in the 9th century, surrounded by lakeside gardens, horse-riding tracks, boating, and a fresh food market. On its western bank stands the Indo-Saracenic Shalini Palace (built 1931–34), once a royal retreat and now a lakeside landmark with marble arches and tranquil gardens."  
  },
  {
    "title": "New Palace (Chatrapati Shahu Museum)",
    "description": "Constructed in black basalt and red sandstone between 1877–84, this octagonal palace houses the Shahu Museum, showcasing royal memorabilia—costumes, weapons, trophies, stuffed wildlife—and ornate Darbar Hall with stained glass scenes from Shivaji’s life. A regal journey into Kolhapur's heritage."  
  },
  {
    "title": "Panhala Fort",
    "description": "About 20 km from the city, this sprawling 12th-century hill fort offers zigzag ramparts, hidden wells (Andhar Bavadi), majestic Teen Darwaza gateway, and rich Maratha-era history—including the Battle of Pavan Khind and Mughal-Maratha sieges. Panoramic Sahyadri views await at every turn."  
  },
  {
    "title": "Panhala – Jyotiba Temple",
    "description": "Perched atop a hill at ~3,100 ft and ~18 km from Kolhapur, this vibrant Shakti-Peetha complex draws devotees in thousands during Chaitra and Kartiki Pournima. Apart from spiritual appeal, the site offers sweeping valley views and a traditional pilgrimage experience."  
  },
  {
    "title": "Koteshwar Temple",
    "description": "A serene riverside Shiva temple on the banks of the Krishna River, renowned for its calm ambience and exquisite carvings. The nearby forested setting and sacred sanctity make it a peaceful site for devotees and seekers of solitude."  
  },
  {
    "title": "Kopeshwar Temple (Khidrapur)",
    "description": "A remarkable 12th-century Shiva temple built by the Shilahara dynasty, located ~15 km from town. Known for its conical sanctum and finely carved stone sculptures, it's an architectural gem of Kolhapur’s ancient heritage."  
  },
  {
    "title": "Bhavani Mandap & Khasbag Maidan",
    "description": "Situated near Mahalakshmi Temple, the historical Bhavani Mandap hosts statues, ancient pillared halls, and cultural events. Adjacent, Khasbag Maidan is a sprawling ground where traditional wrestling (kushti) is still practiced amid local celebrations."  
  },
  {
    "title": "Dajipur (Radhanagari) Wildlife Sanctuary",
    "description": "About 45 km from Kolhapur, this protected sanctuary was Maharashtra’s first wildlife reserve. Home to Indian bison (gaur), leopards, sloth bears, and over 150 bird species, it lies within the biodiverse Western Ghats and offers safari drives in a lush, eco-sensitive terrain."  
  },
  {
    "title": "Chambukadi & Pachgaon Hills",
    "description": "Local favorite hilltops within city limits, ideal for short treks and golden-hour views. Chambukadi Tekdi and Pachgaon Tekdi offer panoramic city vistas and are beloved by Pune locals for evening walks and skyline photography."  
  }
],

       "services": [
    {
      "name": "Pune to Goa Innova Crysta Cab Booking",
      "description": "Book your Pune to Goa journey with our Innova Crysta cab service for a perfect blend of comfort, space, and reliability. Ideal for long road trips, our cabs are equipped with spacious interiors, air conditioning, and experienced chauffeurs for a smooth coastal drive across the scenic Western Ghats."
    },
    {
      "name": "One Way Innova Crysta Pune Goa",
      "description": "Planning a one-way trip to Goa from Pune? Our one-way Innova Crysta cab offers a cost-effective option with full privacy, ample luggage space, and a relaxing travel experience without any return charges. Ideal for solo travelers, families, and small groups."
    },
    {
      "name": "Round Trip Innova Crysta Pune Goa",
      "description": "Opt for our round-trip Innova Crysta cab service if you're planning a Goa vacation with return travel. Our vehicle stays with you or comes back to pick you up—offering flexible return scheduling, comfort, and professional support throughout your journey."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Goa",
      "description": "Travel in comfort from Pune to Goa with our fully air-conditioned Innova Crysta taxis. Designed for long distances, our AC cabs offer a pleasant and cool environment throughout the 9-10 hour journey, especially during summer months."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Goa",
      "description": "Enjoy the drive to Goa with our courteous, professional chauffeurs who are well-versed with the Pune-Goa route. Our drivers ensure timely pickups, safety, and a stress-free travel experience for all passengers."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Goa",
      "description": "Book a private Innova Crysta taxi for your Pune to Goa trip and enjoy exclusive access to a clean, well-maintained SUV. No ride sharing—just pure comfort, flexibility, and a vehicle reserved solely for you and your companions."
    },
    {
      "name": "Online Booking Innova Crysta Pune Goa",
      "description": "Use our seamless online booking system to reserve your Pune to Goa Innova Crysta cab. Enjoy real-time availability, secure payments, transparent pricing, and immediate confirmation—all in a few simple clicks."
    },
    {
      "name": "Goa Holiday Innova Crysta Cab",
      "description": "Start your Goa holiday in style with our holiday-special Innova Crysta cab services. Perfect for beach getaways, party groups, and couples, our cabs offer flexible travel timing, luggage support, and comfortable reclining seats for the road trip ahead."
    },
    {
      "name": "Family Goa Trip Innova Crysta",
      "description": "Planning a family vacation from Pune to Goa? Our Innova Crysta cabs are ideal with seating for 6-7 people, extra boot space, and a smooth ride—making sure everyone, from kids to elders, enjoys the journey."
    },
    {
      "name": "Goa Airport Transfer Innova Crysta",
      "description": "We also offer Pune to Goa airport drop services in Innova Crysta cabs. Our punctual pickups and professional drivers ensure you reach Goa International Airport comfortably and on time, even for early morning or late-night flights."
    },
    {
      "name": "Comfortable Innova Crysta Goa Taxi",
      "description": "Our Innova Crysta taxis provide unmatched comfort with ergonomic seats, ample legroom, smooth suspension, and quiet cabins—making them perfect for the long drive to Goa, especially for those seeking a relaxed road trip."
    },
    {
      "name": "Affordable Innova Crysta Cab Pune Goa",
      "description": "Enjoy luxury at a competitive price with our affordable Pune to Goa Innova Crysta cab service. Choose from custom packages with transparent pricing—ideal for travelers who want both savings and quality."
    },
    {
      "name": "Luxury Innova Crysta Goa Taxi",
      "description": "Travel in style with our luxury Innova Crysta taxi services to Goa. With plush interiors, captain seats, and premium features, this cab is perfect for high-end travelers, couples, and executives looking for a deluxe travel experience."
    },
    {
      "name": "Goa Sightseeing Innova Crysta",
      "description": "Extend your trip with a Goa sightseeing package in our Innova Crysta. Visit beaches, forts, churches, and spice farms with ease and comfort—perfect for groups who want full-day access to a dedicated vehicle."
    },
    {
      "name": "Reliable Pune Goa Innova Crysta Cab",
      "description": "Trust our reliable cab services for your Pune to Goa travel needs. We offer verified drivers, well-maintained vehicles, and 24/7 customer support—ensuring a safe and dependable ride every time."
    }
  ],
  "tableData": [
    ["Pune to Goa Innova Crysta Cab Booking", "One Way Innova Crysta Pune Goa"],
    ["Round Trip Innova Crysta Pune Goa", "AC Innova Crysta Taxi Pune Goa"],
    ["Chauffeur Driven Innova Crysta Pune Goa", "Private Innova Crysta Taxi Pune Goa"],
    ["Online Booking Innova Crysta Pune Goa", "Goa Holiday Innova Crysta Cab"],
    ["Family Goa Trip Innova Crysta", "Goa Airport Transfer Innova Crysta"],
    ["Comfortable Innova Crysta Goa Taxi", "Affordable Innova Crysta Cab Pune Goa"],
    ["Luxury Innova Crysta Goa Taxi", "Goa Sightseeing Innova Crysta"],
    ["Reliable Pune Goa Innova Crysta Cab", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable Innova Crysta Cab Service from Pune to Goa",
    "WhyChoosedescription": "Enjoy a luxurious and spacious ride from Pune to Goa in our Innova Crysta cabs. Ideal for families, groups, and business travelers, our service ensures a smooth and relaxing journey across approximately 450 km of scenic highways."
  },
  {
    "WhyChooseheading": "Spacious Interiors and Premium Comfort",
    "WhyChoosedescription": "Our Innova Crysta offers plush seating for up to 6–7 passengers, dual-zone air conditioning, and ample luggage space—making it perfect for long road trips with family or friends heading to Goa’s beaches and resorts."
  },
  {
    "WhyChooseheading": "Experienced and Safe Drivers",
    "WhyChoosedescription": "Our professional drivers are trained for long-distance travel and familiar with the Pune to Goa route. They prioritize your safety and comfort, ensuring timely pickups, smooth driving, and convenient stops along the way."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
    "WhyChoosedescription": "All our Innova Crysta cabs undergo regular maintenance and rigorous cleaning protocols to provide a hygienic and reliable travel experience, especially for extended journeys like Pune to Goa."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Suit Your Trip",
    "WhyChoosedescription": "Whether you need a one-way drop, round trip, or multi-day rental with local sightseeing in Goa, we offer customizable packages that fit your itinerary and travel preferences."
  },
  {
    "WhyChooseheading": "Transparent and All-Inclusive Pricing",
    "WhyChoosedescription": "Our fares cover fuel, tolls, driver allowance, and taxes with no hidden charges, offering excellent value for premium Innova Crysta cab service between Pune and Goa."
  },
  {
    "WhyChooseheading": "Perfect for Leisure, Corporate, and Group Travel",
    "WhyChoosedescription": "Whether it’s a leisure vacation, corporate retreat, or group trip, our Innova Crysta cabs provide the comfort and space needed for an enjoyable journey to Goa."
  },
  {
    "WhyChooseheading": "24/7 Customer Support and Easy Online Booking",
    "WhyChoosedescription": "Book your Pune to Goa Innova Crysta cab anytime with our round-the-clock customer service. Our team is always ready to assist with booking, itinerary changes, or special requests for a hassle-free experience."
  }
]


















    }

const faqData = [
    {
        question: "How do I book an Innova Crysta cab from Pune to Goa?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or using our website for instant booking confirmation."
    },
    {
        question: "What is the distance and travel time from Pune to Goa?",
        answer: "The distance is around 450 to 500 km depending on the route, with a travel time of approximately 9 to 11 hours."
    },
    {
        question: "Is Innova Crysta a good choice for a Pune to Goa road trip?",
        answer: "Absolutely. The Innova Crysta offers a comfortable, spacious, and smooth ride, perfect for long journeys like Pune to Goa."
    },
    {
        question: "Can I book a one-way or round trip to Goa?",
        answer: "Yes, Meghana Cab provides both one-way and round-trip options for your convenience."
    },
    {
        question: "How many passengers can the Innova Crysta accommodate?",
        answer: "The Innova Crysta comfortably seats 6 to 7 passengers along with luggage."
    },
    {
        question: "Are your vehicles sanitized before each trip?",
        answer: "Yes, all our cabs are cleaned and sanitized thoroughly before every ride for your safety."
    },
    {
        question: "What’s included in the fare for the Pune to Goa trip?",
        answer: "The fare includes driver charges, fuel, and tolls. Extra charges may apply for parking or additional stops."
    },
    {
        question: "Can we stop for sightseeing or meals on the way to Goa?",
        answer: "Yes, you can request additional stops. Just let us know your plan during booking."
    },
    {
        question: "Are your drivers experienced with the Pune-Goa route?",
        answer: "Yes, all drivers are experienced with this route and ensure a safe, enjoyable journey."
    },
    {
        question: "What payment methods do you support?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Pravin Desai',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Our Pune to Goa trip was fantastic. The Innova Crysta was clean, comfortable, and the journey was smooth throughout.”',
    },
    {
        name: 'Ms. Anuja D’Souza',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Highly recommend Meghana Cab for long trips. We had a great experience traveling to Goa with excellent service and a courteous driver.”',
    },
];





























































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const puneGoaInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Goa Innova Crysta Cab Service",
  "description": "Reliable and comfortable Innova Crysta taxi service from Pune to Goa for holidays, family trips, airport transfers, and sightseeing. Chauffeur-driven, affordable, and premium cab service.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Taxi Service",
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "City",
      "name": "Goa"
    }
  ],
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-goa-innova-crysta-cab"
  }
};







    return (
        <div>

<Helmet>
  <title>Pune to Goa Innova Crysta Cab Service | Reliable Taxi Booking</title>
  <meta
    name="description"
    content="Book Innova Crysta cabs from Pune to Goa for holidays, airport transfers, family trips, and sightseeing. Affordable, luxury, and chauffeur-driven taxi service."
  />
  <meta
    name="keywords"
    content="Pune to Goa Innova Crysta Cab Booking, One Way Innova Crysta Pune Goa, Round Trip Innova Crysta Pune Goa, AC Innova Crysta Taxi Pune Goa, Chauffeur Driven Innova Crysta Pune Goa, Private Innova Crysta Taxi Pune Goa, Online Booking Innova Crysta Pune Goa, Goa Holiday Innova Crysta Cab, Family Goa Trip Innova Crysta, Goa Airport Transfer Innova Crysta, Comfortable Innova Crysta Goa Taxi, Affordable Innova Crysta Cab Pune Goa, Luxury Innova Crysta Goa Taxi, Goa Sightseeing Innova Crysta, Reliable Pune Goa Innova Crysta Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneGoaInnovaSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/17.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetogoainnovacrystacabservice;